import script from "./base-sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./base-sidebar.vue?vue&type=style&index=0&id=97136cfe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97136cfe"]])

export default __exports__